<template>
  <Modal
    :darker="true"
    :boldFonts="true"
    :headerTitle="'Graphics Library'"
    :hideCancelButton="true"
    :isAboveAll="true"
    :confirmationText="'Select Graphic'"
    :disableConfirmationButton="!selectedGraphic"
    @closeModal="$emit('closeModal')"
    @confirm="$emit('setGraphic', selectedGraphic)"
  >
    <template #content>
      <section id="filters">
        <!-- Categories -->
        <v-select
          :value="categoryFilter"
          :options="graphicsCategories"
          :clearable="false"
          @input="(category) => (categoryFilter = category)"
        >
        </v-select>

        <!-- Search Input -->
        <label class="input-label input-in-row" for="search-graphic">
          <input
            class="input-label slate-bold"
            type="text"
            id="search-graphic"
            name="search-graphic"
            v-model="searchFilter"
            placeholder="Search"
          />
          <img src="@/assets/icons/ui/save-circle.svg" alt="search icon" />
        </label>
      </section>

      <section
        id="filtered-graphics"
        v-if="filteredGraphics && filteredGraphics.length"
      >
        <article
          class="graphic-item"
          :class="{ selected: graphic.id === selectedGraphicId }"
          :key="'graphic-' + i"
          v-for="(graphic, i) in filteredGraphics"
          @click="selectedGraphicId = graphic.id"
        >
          <img :src="graphic.thumbnail" alt="" />
          <p class="graphic-name slate-bold">{{ graphic.name }}</p>
        </article>
      </section>
      <p
        class="text-center"
        v-if="filteredGraphics && !filteredGraphics.length"
      >
        No match
      </p>

      <!-- Footer -->

      <Loader
        v-if="loading"
        :withMessage="true"
        :message="'Loading library...'"
      />
    </template>
  </Modal>
</template>

<script>
import axios from "axios";
import Modal from "@/components/Utils/Modal";
import Loader from "@/components/Utils/Loader.vue";

export default {
  name: "GraphicsLibraryModal",
  components: { Loader, Modal },

  data() {
    return {
      graphics: {},
      categoryFilter: "",
      searchFilter: "",
      loading: false,
      selectedGraphicId: null,
    };
  },

  computed: {
    filteredGraphics() {
      const filteredByCategory =
        this.graphics[this.categoryFilter] ||
        this.graphics[this.graphicsCategories?.[0]];

      return filteredByCategory?.filter((graphic) => {
        const name = graphic && graphic.name.toLowerCase();
        return name.includes(this.searchFilter.toLowerCase());
      });
    },

    graphicsCategories() {
      return Object.keys(this.graphics);
    },

    selectedGraphic() {
      if (!this.filteredGraphics || !this.selectedGraphicId) {
        return null;
      }

      return this.filteredGraphics?.find(
        (g) => g.id === this.selectedGraphicId
      );
    },
  },

  methods: {
    async getGraphics() {
      try {
        this.loading = true;
        const url = `${process.env.VUE_APP_ENDPOINT}api/landings/graphics`;
        const { data } = await axios.get(url);
        this.graphics = data;
        this.categoryFilter = Object.keys(data)[0];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.getGraphics();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
  max-height: 75% !important;
  min-height: 500px;
  width: 75% !important;
  max-width: 900px !important;
  overflow: hidden;
  position: relative;

  .header {
    p {
      margin: auto !important;
      text-align: center !important;
      font-size: 1.25rem;
    }
  }
  .content {
    height: 500px !important;
  }

  .buttons-container {
    box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.102);
    justify-content: end !important;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: white;
    button {
      margin-right: 1.5rem;
      text-transform: uppercase !important;
    }
  }
}
#filters {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;

  & > * {
    width: 25%;
    margin: 0;
    border-radius: 6px;
    height: 3rem;

    input {
      border: none;
      &:focus,
      &:focus-visible {
        border: none;
        outline: none;
      }
    }

    ::v-deep .vs__dropdown-toggle {
      height: 100%;
    }
  }

  label {
    border: 1px solid $grey-light;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    display: flex;
    align-items: center;
    input::placeholder {
      color: $placeholder;
      font-family: "SlateStd-Light", arial, sans-serif;
    }
    img {
    }
  }
}

#filtered-graphics {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  // max-height: 350px;
  gap: 1rem;
  overflow-y: auto;

  .graphic-item {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    height: 160px;
    width: 140px;
    border: 1px solid $grey-light;
    border-radius: 3px;
    margin-bottom: 1.5rem;
    transition: all 0.1s;

    &:hover {
      cursor: pointer;
      box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.25);
    }

    &.selected {
      box-shadow: 0 0 5px 1px #70b78b;
    }

    img {
      margin-bottom: 0.5rem;
    }

    .graphic-name {
      text-align: center;
    }
  }
}
</style>
